import axios from 'axios';
import { API_BASE_URL } from '../api';

// Get all notifications
export const getNotifications = (token, page = 1, limit = 20, unreadOnly = false) =>
  axios.get(`${API_BASE_URL}/notifications`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { page, limit, unreadOnly }
  });

// Get unread count
export const getUnreadCount = (token) =>
  axios.get(`${API_BASE_URL}/notifications/unread-count`, {
    headers: { Authorization: `Bearer ${token}` }
  });

// Mark notification as read
export const markAsRead = (notificationId, token) =>
  axios.patch(`${API_BASE_URL}/notifications/${notificationId}/read`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });

// Mark all notifications as read
export const markAllAsRead = (token) =>
  axios.patch(`${API_BASE_URL}/notifications/mark-all-read`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });

// Delete notification
export const deleteNotification = (notificationId, token) =>
  axios.delete(`${API_BASE_URL}/notifications/${notificationId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

// Delete all notifications
export const deleteAllNotifications = (token) =>
  axios.delete(`${API_BASE_URL}/notifications`, {
    headers: { Authorization: `Bearer ${token}` }
  });
